import { render, staticRenderFns } from "./DeleteActionPlanModal.vue?vue&type=template&id=2546c173&"
import script from "./DeleteActionPlanModal.vue?vue&type=script&lang=js&"
export * from "./DeleteActionPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports